import { ComponentProps } from 'react';
import Button from '@alltrails/denali/components/Button';
import styles from './styles/styles.module.scss';

type ButtonDefinition = Pick<
  ComponentProps<typeof Button>,
  'icon' | 'linkInfo' | 'loading' | 'onClick' | 'text' | 'disabled' | 'className' | 'allowWrap' | 'variant'
>;

type FooterButtonsProps = {
  experimental?: boolean;
  fill?: boolean;
  defaultButton?: ButtonDefinition & { placement?: 'left' | 'right' };
  destructiveButton?: ButtonDefinition & { placement?: 'left' | 'right' };
  flatButton?: ButtonDefinition & { placement?: 'left' | 'right' };
  primaryButton?: ButtonDefinition;
};

const FooterButtons = ({ fill, defaultButton, destructiveButton, flatButton, primaryButton, experimental }: FooterButtonsProps) => {
  // Design https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=7322-32327&m=dev
  if (experimental) {
    return (
      <>
        <div className={styles.gradient} />
        {defaultButton && <Button {...defaultButton} variant="secondary" width="full" />}
        {flatButton && <Button {...flatButton} variant="ghost" width="full" />}
        {primaryButton && <Button {...primaryButton} variant={primaryButton.variant ?? 'primary'} width="full" />}
        {destructiveButton && <Button {...destructiveButton} variant={destructiveButton.variant ?? 'destructive'} width="full" />}
      </>
    );
  }

  return fill ? (
    <div className={styles.fillContainer}>
      {destructiveButton && <Button {...destructiveButton} variant="destructive" width="full" />}
      {defaultButton && <Button {...defaultButton} variant="secondary" width="full" />}
      {flatButton && <Button {...flatButton} variant="ghost" width="full" />}
      {primaryButton && <Button {...primaryButton} variant={primaryButton.variant ?? 'primary'} width="full" />}
    </div>
  ) : (
    <div className={styles.container}>
      <div className={styles.leftButtons}>
        {destructiveButton && (!destructiveButton.placement || destructiveButton.placement === 'left') && (
          <Button {...destructiveButton} variant="destructive" width="auto" />
        )}
        {defaultButton && (!defaultButton.placement || defaultButton.placement === 'left') && (
          <Button {...defaultButton} variant="secondary" width="auto" />
        )}
        {flatButton && flatButton.placement === 'left' && <Button {...flatButton} variant="ghost" width="auto" />}
      </div>
      <div className={styles.rightButtons}>
        {destructiveButton && destructiveButton.placement === 'right' && <Button {...destructiveButton} variant="destructive" width="auto" />}
        {flatButton && (!flatButton.placement || flatButton.placement === 'right') && <Button {...flatButton} variant="ghost" width="auto" />}
        {defaultButton && defaultButton.placement === 'right' && <Button {...defaultButton} variant="secondary" width="auto" />}
        {primaryButton && <Button {...primaryButton} variant={primaryButton.variant ?? 'primary'} width="auto" />}
      </div>
    </div>
  );
};

export default FooterButtons;
